export const TestimonialsTableColumns = (isArabic) => [
    { id: 'name', label: isArabic ? 'العميل' : 'Client Name', align: 'start' },
    { id: 'rating', label: isArabic ? 'التقييم' : 'Rating', align: 'center' },
    { id: 'show_in_home', label: isArabic ? 'الحالة' : 'Status', align: 'center' },
    { id: 'sort_order', label: isArabic ? 'الترتيب' : 'Sort Order', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' },
];
